import React, { useState, useEffect, useCallback } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import qs from 'query-string'
import { useHistory, useLocation } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import EditIcon from '@material-ui/icons/Edit';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Switch,
  FormControlLabel,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  FormGroup,
  Typography,
  IconButton
} from '@material-ui/core';
import EnhancedTableHead from "../../../components/common/EnhancedTableHead";
import CustomTablePagination from "../../../components/common/CustomPagination";
import { tablestyle, getComparator, stableSort, trimFilters, getDeviceType } from '../../../utils'
import TableLoader from "../../../components/common/TableLoader";
import DeleteIcon from '@material-ui/icons/Delete';
import CustomAddModal from '../../../components/common/CustomAddModal'
import validation from '../../Validation'
import * as commonActions from '../../common/actions'
import * as OTAAction from '../OTAs/actions'
import * as actions from './actions'
import Input from '../../../components/common/Input'
import CustomDrawer from "../../../components/common/CustomDrawer";
import CustomAccordion from "../../../components/common/CustomAccordion";
import CustomSearchBar from "../../../components/common/CustomSearchBar";
import SearchFilterButtons from "../../../components/common/SearchFilterButtons";
import CusBackdrop from '../../../components/common/Backdrop'
import { getAllTags } from "../HeatPumpDevices/actions";
import SelectBox from "../../../components/common/selectBox";

const ota_types = [
  { value: "versioning", label: "Current Version" },
  { value: "series_type", label: "Series Type" },
  { value: "tag", label: "Tag" },
]

const manageHead = [
  { id: 'name', sortByKey: 'name', label: "Name", className: "show-pointer" },
  { id: 'from_version', sortByKey: 'from_version', label: "Version/Tags/Series Type", className: "show-pointer" },
  { id: 'to_version', sortByKey: 'to_version', label: "Upgraded To", className: "show-pointer" },
  { id: 'upgrade', sortByKey: 'immediate_update', label: "Upgrade", className: "show-pointer" },
  { id: "action", sortByKey: 'action', label: "Actions", stickyClassName: "more" }
];

const initialRule = {
  to: '',
  ota_type: 'versioning',
  from_version: '',
  upgrade: false,
  name: ''
}

const initialAccordion = {
  ruleNameAcc: false,
  fromVersionAcc: false,
  toVersionAcc: false
}

const initialFilter = {
  isOpen: false,
  name: '',
  from_version: '',
  to_version: '',
  limit: 25,
  page: 1,
  sortBy: '',
  orderBy: 'desc'
}

function Aggregates(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { allRule = {}, isLoading = false } = useSelector(state => state.ruleReducer)
  const { allTags = {}, allTagsLoading = false } = useSelector(state => state.heatPumpDevices || {})
  const { firmwareList = [] } = useSelector(state => state.OTA)
  const { data, total = 0 } = allRule

  const [refresh, setRefresh] = useState(false);
  const [rule, setRule] = useState({ ...initialRule })
  const [deleteRuleId, setdeleteRuleId] = useState('')
  const [randomValue, setRandomvalue] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [btnTitle, setBtnTitle] = useState('ADD')
  const [errors, setErrors] = useState({})
  const [editMode, setEditMode] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const [accordion, setAccordian] = useState({ ...initialAccordion })
  const [newFilters, setNewFilters] = useState({ ...initialFilter })
  const [goToPage, setGoToPage] = useState('')
  const [clearFilterLoader, setClearFilterLoader] = useState(false)

  const delaySearch = useCallback(_.debounce(filters => refreshRules(filters), 500), []);
  const delayGoToPagination = useCallback(_.debounce(filters => goToPageFun(filters), 1000), []);

  const refreshRules = (filters) => {
    dispatch(actions.getAllRule(filters))
  }

  const goToPageFun = (value) => {
    refreshRules(value)
    // setNewFilters({ ...filters, page: parseInt(value) })
  }

  const onClickRefresh = () => {
    setRefresh(true)
    dispatch(actions.getAllRule(newFilters)).then(() => setRefresh(false)).catch(err => setRefresh(false))
  }

  const onPageChange = (e, page) => {
    refreshRules({ ...newFilters, page })
    setNewFilters({ ...newFilters, page })
  }

  const isValid = () => {
    const { isValid, errors } = validation.addRule(rule)
    if (!isValid) {
      setErrors(errors)
    };
    return isValid;
  }

  const onSubmitModal = () => {
    if (isValid()) {
      let obj = {
        ota_type: rule.ota_type,
        name: rule.name,
        from_version: rule.from_version,
        to_version: rule.to,
        immediate_update: rule.upgrade,
        deviceType: getDeviceType()
        // schedule_on: "2021-01-01 15:00:00"
      }
      if (editMode) {
        obj = {
          ...obj,
          id: selectedId
        }
        dispatch(actions.updateRule(obj)).then(res => {
          refreshRules(newFilters)
          handleModalClose()
        })
      } else {
        dispatch(actions.addNewRule(obj)).then(res => {
          refreshRules(newFilters)
          handleModalClose()
        })
      }
    }
  }

  const enableEditMode = (item) => {
    setSelectedId(item.id)
    setRule({ ...rule, to: item.to_version, from_version: item.from_version, upgrade: item.immediate_update, name: item.name, ota_type: item.ota_type })
    setOpenModal(true)
    setEditMode(true)
    setBtnTitle('Update')
  }

  const handleModalClose = () => {
    setSelectedId('')
    setRule({ ...initialRule })
    setOpenModal(false)
    setEditMode(false)
    // setBtnTitle('Add')
    setErrors({})
  }

  const onDeleteRetailer = (id) => {
    setdeleteRuleId(id)
    setRandomvalue(Math.random())
  }

  const deleteRule = () => {
    dispatch(actions.deleteRule(deleteRuleId)).then(res => {
      setNewFilters({ ...newFilters, limit: newFilters?.limit, page: 1, sortBy: 'created_at', orderBy: 'desc' })
      refreshRules({ ...newFilters, limit: newFilters?.limit, page: 1, sortBy: 'created_at', orderBy: 'desc' })
      setdeleteRuleId('')
    })
  }

  const onChangeLimit = (e) => {
    refreshRules({ ...newFilters, limit: e.target.value, page: 1, sortBy: 'created_at', orderBy: 'desc', })
    setNewFilters({ ...newFilters, limit: e.target.value, page: 1, })
    setGoToPage('')

  }

  const onSortBy = (label) => {
    if (!label || label === "action") return
    let orderBy = ''
    if (newFilters.orderBy === 'desc') {
      orderBy = 'asc'
    } else {
      orderBy = 'desc'
    }
    const tempFilter = { ...newFilters, sortBy: label, orderBy: orderBy }
    setNewFilters(tempFilter)
    refreshRules(tempFilter)
  }

  // const clearFilter = () => {
  //     setNewFilters({ ...initialFilter })
  //     refreshRules(initialFilter)
  // }

  const handleChangeRule = (e, key) => {
    if (key === 'name' && e.target.value.length > 40) return
    if (key === "upgrade") {
      setRule({ ...rule, [key]: e.target.checked })
      return
    } else {
      setRule({ ...rule, [key]: e.target.value })
      setErrors({ ...errors, [key]: '' })
    }
  }

  const handleChangeEnableRule = (e, item) => {
    let obj = {
      ...item,
      immediate_update: e.target.checked,
      // schedule_on: "2021-01-01 15:00:00"
    }
    dispatch(actions.updateRule(obj)).then(res => {
      refreshRules(newFilters)
    })
  }

  const onChangeGoToPage = ({ target: { value = '' } }) => {
    if (!value.match(/^[0-9]*$/) || value === "0") return
    let pageValue = Math.ceil(total / newFilters.limit)
    if (value > pageValue) return
    setGoToPage(value ? parseInt(value) : '')
    setNewFilters({ ...newFilters, page: value ? parseInt(value) : '' })
    // delayGoToPagination({ ...newFilters, page: value })
  }

  const openFilterSidebar = () => {
    setNewFilters({ ...newFilters, isOpen: true })
  }

  const onCloseFiltersDrawer = () => {
    setNewFilters({ ...newFilters, isOpen: false })
  }

  const handleChangeAccordion = (panel, filterKey) => (event, isExpanded) => {
    if (!isExpanded) {
      setNewFilters({ ...newFilters, [filterKey]: '', page: newFilters[filterKey]?.length ? 1 : newFilters.page })
    }
    setAccordian({ ...accordion, [panel]: isExpanded })
    // if (newFilters[filterKey]?.length) {
    //     refreshRules({ ...newFilters, [filterKey]: '', page: 1 })
    // }
  };

  const onChangeFilter = ({ target: { name = '', value = '' } }) => {
    if (!name) return;
    setNewFilters(prev => ({ ...prev, [name]: value, page: 1 }))
    // delaySearch({ ...tempFilter })
  }

  const applyFilter = () => {
    refreshRules({ ...trimFilters(newFilters), page: 1 })
  }

  const clearFilter = () => {
    setClearFilterLoader(true)
    let tempFilter = {
      isOpen: newFilters.isOpen,
      serial_number: '',
      firmware_version: '',
      upgradable: [],
      limit: 25,
      page: 1,
      sortBy: '',
      orderBy: 'desc'
    }

    setNewFilters({ ...tempFilter })
    setAccordian({ ...initialAccordion })
    dispatch(actions.getAllRule(tempFilter)).then(res => {
      setClearFilterLoader(false)
    })
  }

  const onChangeKeyDown = (e) => {
    if (e.key === 'Enter') {
      refreshRules({ ...trimFilters(newFilters), page: 1 })
    }
  }

  useEffect(() => {
    dispatch(OTAAction.getAllOTA({}));
    dispatch(getAllTags());

    let tempFilter = {}
    if (location.search) {
      let data = { ...qs.parse(location.search, { arrayFormat: 'bracket', }) }
      let {
        ruleNameAcc = false,
        fromVersionAcc = false,
        toVersionAcc = false,
        isOpen = false,
        name = '',
        from_version = '',
        to_version = '',
        limit = 25,
        page = 1,
        sortBy = '',
        orderBy = 'desc'
      } = data

      tempFilter = {
        isOpen: isOpen === "false" ? false : true,
        name,
        from_version,
        to_version,
        limit: parseInt(limit),
        page: parseInt(page),
        sortBy,
        orderBy,
      }

      let tempAcc = {
        ruleNameAcc: ruleNameAcc === "false" ? false : true,
        fromVersionAcc: fromVersionAcc === "false" ? false : true,
        toVersionAcc: toVersionAcc === "false" ? false : true
      }

      setNewFilters(tempFilter)
      setAccordian(tempAcc)
    }
    refreshRules(tempFilter)
    return () => {
      dispatch(actions.clearStoreForRule())
    }
  }, [])

  useEffect(() => {
    let tempFilter = { ...accordion, ...trimFilters(newFilters) }
    location.search = qs.stringify({ ...tempFilter })
    history.push({
      pathname: '/admin/rules',
      search: location.search
    })
  }, [accordion, newFilters])

  useEffect(() => {
    if (openModal === false)
      setTimeout(() => {
        setBtnTitle('Add')
      }, 150)
  }, [openModal])

  useEffect(() => {
    if (deleteRuleId) {
      dispatch(commonActions.openDeleteModal({
        confirmAction: deleteRule,
        title: 'DELETE RULE',
        dialogtext: 'Are you sure you want to delete this Rule?'
      }))
    }
  }, [randomValue])

  const { t = () => { }, toast, classes } = props;
  let searchVersionList = firmwareList?.length ? firmwareList.map(res => ({ label: res.version || '', value: res.version || '' })) : []

  return (
    <Grid container className="location-container heatdb-p0" >
      {/* Filters bar */}
      <Grid item xs={12} >
        <Grid container className="location-head">
          <Grid item xs={12} sm={12} lg={6} md={4} className="heading">
            <h2>Rules</h2>
          </Grid>
          <Grid item xs={12} sm={12} lg={6} md={8}>
            <div className="search-add">
              <Button className="button-btn btn-custom-primary mr-3" onClick={() => setOpenModal(true)}><AddIcon />Add Rule</Button>
              <IconButton aria-label="filter" onClick={openFilterSidebar}>
                <FilterListIcon />
                <Typography variant="body1" style={{ marginLeft: 8 }}>
                  Search
                </Typography>
              </IconButton>
              <CustomDrawer isOpen={newFilters.isOpen} onClose={onCloseFiltersDrawer} >
                <ul className="list-style-list">
                  <CusBackdrop open={isLoading} className="loader-images" />
                  <li>
                    <CustomAccordion
                      isOpen={accordion.ruleNameAcc}
                      handleChange={handleChangeAccordion('ruleNameAcc', 'name')}
                      label={"Rule Name"}
                    >
                      <CustomSearchBar
                        placeholder="Enter Rule Name"
                        value={newFilters.name}
                        onChange={onChangeFilter}
                        name={'name'}
                        onChangeKeyDown={onChangeKeyDown}
                      />
                    </CustomAccordion>
                  </li>
                  {getDeviceType() === "heat_pump" &&
                    <li>
                      <CustomAccordion
                        isOpen={accordion.otaTypeAcc}
                        handleChange={handleChangeAccordion('otaTypeAcc', 'ota_type')}
                        label={"Upgrade From"}
                      >
                        <FormControl variant="outlined" className="" fullWidth >
                          <SelectBox
                            options={ota_types}
                            value={ota_types?.find(type => type.value === newFilters.ota_type)}
                            onChange={(selected) => {
                              onChangeFilter({ target: { name: "ota_type", value: selected.value } })
                              onChangeFilter({ target: { name: "from_version", value: "" } })
                            }}
                          />
                        </FormControl>
                      </CustomAccordion>
                    </li>
                  }
                  {((getDeviceType() === "heat_pump" && newFilters.ota_type) || getDeviceType() !== "heat_pump") && (() => {
                    let options = [];
                    if (newFilters.ota_type === "series_type") {
                      options = [
                        { value: "select", label: "Select" },
                        { value: "pro", label: "Pro" },
                        // { value: "ultra", label: "Ultra" }
                      ];
                    } else if (newFilters.ota_type === "tag") {
                      options = allTags && allTags.length ? allTags.map((tag) => ({
                        value: tag.id,
                        label: tag.name,
                      })) : [];
                    } else {
                      options = searchVersionList?.length ? searchVersionList : [];
                    }

                    return (
                      <li>
                        <CustomAccordion
                          isOpen={accordion.fromVersionAcc}
                          handleChange={handleChangeAccordion('fromVersionAcc', 'from_version')}
                          label={newFilters.ota_type === "series_type" ? "Series Type" : newFilters.ota_type === "tag" ? "Tags" : "Version"}
                        >
                          <FormControl variant="outlined" fullWidth>
                            <SelectBox
                              options={options}
                              value={options?.find(type => type.value === newFilters.from_version) || ""}
                              onChange={(selected) => {
                                onChangeFilter({ target: { name: "from_version", value: selected.value } });
                              }}
                            />
                          </FormControl>
                        </CustomAccordion>
                      </li>
                    )
                  })()}
                  <li>
                    <CustomAccordion
                      isOpen={accordion.toVersionAcc}
                      handleChange={handleChangeAccordion('toVersionAcc', 'to_version')}
                      label={"Upgraded To"}
                    >
                      <FormControl variant="outlined" fullWidth>
                        <SelectBox
                          options={searchVersionList}
                          value={searchVersionList?.find(type => type.value === newFilters.to_version) || ""}
                          onChange={(selected) => {
                            onChangeFilter({ target: { name: "to_version", value: selected.value } });
                          }}
                        />
                      </FormControl>
                    </CustomAccordion>
                  </li>
                  <li>
                    <SearchFilterButtons
                      clearFilter={clearFilter}
                      applyFilter={applyFilter}
                      isLoading={isLoading}
                      clearFilterLoader={clearFilterLoader}
                    />
                  </li>
                </ul>
              </CustomDrawer>
            </div>
          </Grid>
        </Grid>
      </Grid>

      {/* rules listing */}
      <Grid item xs={12} sm={12} md={12} lg={12} className="content-container">
        <div id="no-more-tables" className="card-design table-design cf" >

          {
            isLoading ?
              <>
                <TableContainer className={classes.container} style={{ overflow: "hidden" }}>
                  <Table className="table-program" stickyHeader aria-label="sticky table">
                    <EnhancedTableHead
                      headCells={manageHead}
                    />
                  </Table>
                </TableContainer>
                <TableLoader />
              </>
              : null
          }

          {
            !isLoading ? <TableContainer className={classes.container}>
              <Table className="table-program" stickyHeader aria-label="sticky table">
                <EnhancedTableHead
                  headCells={manageHead}
                  onSortBy={onSortBy}
                  filters={newFilters}
                />
                <TableBody>
                  {
                    data?.length ? data.map((item, index) => {
                      return <TableRow key={index} hover role="checkbox" className="cursor_default">
                        <TableCell className="table-custom-width">{item?.name || "-"}</TableCell>
                        <TableCell className="table-custom-width">{item.ota_type === "tag" ? item?.tag_name : item?.from_version}</TableCell>
                        <TableCell className="table-custom-width">{item?.to_version}</TableCell>
                        <TableCell className="table-custom-width">
                          <FormControl component="fieldset">
                            <FormGroup aria-label="position" row>
                              <FormControlLabel
                                // value="top"
                                control={<Switch color="primary"
                                  checked={item.immediate_update}
                                  // disabled={true}
                                  onChange={(e) => handleChangeEnableRule(e, item)}
                                />
                                }
                                // label="Upgrade"
                                labelPlacement="end"
                              />
                            </FormGroup>
                          </FormControl>
                        </TableCell>
                        <TableCell className="table-custom-width more" >
                          <EditIcon className="show-pointer" onClick={() => enableEditMode(item)} />
                          <DeleteIcon className="show-pointer" onClick={() => onDeleteRetailer(item.id)} />
                        </TableCell>
                      </TableRow>
                    })
                      :
                      <TableRow>
                        <TableCell style={{ border: "none" }} colSpan="5" className="table-no-data">No Data Found</TableCell>
                      </TableRow>
                  }
                </TableBody>
              </Table>
            </TableContainer> : null
          }

          <CustomTablePagination
            count={total}
            refresh={refresh}
            onClickRefresh={onClickRefresh}
            filters={newFilters}
            onPageChange={onPageChange}
            onChangeLimit={onChangeLimit}
            onChangeGoToPage={onChangeGoToPage}
            goToPage={goToPage}
          />
        </div>
      </Grid>

      {isLoading ? null
        : <CustomAddModal
          open={openModal}
          handleClose={handleModalClose}
          closeHandler={handleModalClose}
          createBtnTitle={btnTitle}
          title="Rule"
          createHandler={onSubmitModal}
        >
          <Grid container spacing={2}>
            {
              getDeviceType() === "heat_pump" && <Grid item md={6} sm={12} xs={12} className="retailer-error" >
                <FormControl variant="outlined" fullWidth >
                  <InputLabel id="demo-simple-select-outlined-label" >Upgrade From *</InputLabel>
                  <Select
                    label="Upgrade From *"
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={rule.ota_type}
                    onChange={(e) => {
                      handleChangeRule(e, "ota_type");
                      setRule(prev => ({ ...prev, from_version: "" }));
                    }}
                  >
                    {
                      ota_types.map(ota_type => (
                        <MenuItem key={ota_type.value} value={ota_type.value}>{ota_type.label}</MenuItem>
                      ))
                    }
                  </Select>
                  {errors.ota_type && <span className="profile-error">{errors.ota_type}</span>}
                </FormControl>
              </Grid>
            }
            {getDeviceType() === "heat_pump" ?
              <Grid item md={6} sm={12} xs={12} className="retailer-error" >
                <FormControl variant="outlined" fullWidth >
                  <InputLabel id="demo-simple-select-outlined-label" >
                    {rule.ota_type === "versioning" ? "Current Version *"
                      : rule.ota_type === "series_type" ? "Series Type *"
                        : rule.ota_type === "tag" ? "Tag *"
                          : ""}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={rule.from_version}
                    onChange={(e) => handleChangeRule(e, "from_version")}
                    label={rule.ota_type === "versioning" ? "Current Version *"
                      : rule.ota_type === "series_type" ? "Series Type *"
                        : rule.ota_type === "tag" ? "Tag *"
                          : ""}
                  >
                    {
                      rule.ota_type === "versioning"
                        ? firmwareList && firmwareList.length ? firmwareList.map((item, index) => {
                          return <MenuItem value={item.version} key={index}>{item.version}</MenuItem>
                        }) : []
                        : rule.ota_type === "series_type"
                          ?
                          [{ value: "select", label: "Select" }, { value: "pro", label: "Pro" },
                            //  { value: "ultra", label: "Ultra" }
                          ].map(type => (
                            <MenuItem value={type.value}>{type.label}</MenuItem>
                          ))
                          : rule.ota_type === "tag"
                            ? allTags && allTags.length ? allTags.map((tag) => {
                              return <MenuItem value={tag.id} key={tag.id}>{tag.name}</MenuItem>
                            }) : []
                            : []
                    }
                  </Select>
                  {errors.from_version && <span className="profile-error">{errors.from_version}</span>}
                </FormControl>
              </Grid>
              : <Grid item md={6} sm={12} xs={12} className="retailer-error" >
                <FormControl variant="outlined" fullWidth >
                  <InputLabel id="demo-simple-select-outlined-label" >
                    Current Version *
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={rule.from_version}
                    onChange={(e) => handleChangeRule(e, "from_version")}
                    label="Current Version *"
                  >
                    {
                      firmwareList && firmwareList.length ? firmwareList.map((item, index) => {
                        return <MenuItem value={item.version} key={index}>{item.version}</MenuItem>
                      }) : []
                    }
                  </Select>
                  {errors.from_version && <span className="profile-error">{errors.from_version}</span>}
                </FormControl>
              </Grid>

            }
            <Grid item md={6} sm={12} xs={12} className="retailer-error">
              <FormControl variant="outlined" fullWidth >
                <InputLabel id="demo-simple-select-outlined-label" >Upgrade To *</InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={rule.to}
                  onChange={(e) => handleChangeRule(e, "to")}
                  label="Upgrade To *"

                >
                  {
                    firmwareList && firmwareList.length ? firmwareList.map((item, index) => {
                      return <MenuItem value={item.version} key={index}>{item.version}</MenuItem>
                    }) : []
                  }
                </Select>
                {errors.to && <span className="profile-error">{errors.to}</span>}
              </FormControl>
            </Grid>
            <Grid item md={6} sm={12} xs={12} className="retailer-error">
              <Input
                variant="outlined"
                fullWidth
                name="name"
                label="Name *"
                type="text"
                value={rule.name || ""}
                onChange={(e) => handleChangeRule(e, "name")}
              />
              {errors.name && <span className="profile-error">{errors.name}</span>}
            </Grid>
            <Grid item md={6} sm={12} xs={12} className="retailer-error">
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    // value="top"
                    control={<Switch color="primary"
                      checked={rule.upgrade}
                      onChange={(e) => handleChangeRule(e, "upgrade")}
                    />
                    }
                    label="Upgrade"
                    labelPlacement="end"
                  />
                </FormGroup>
              </FormControl>
            </Grid>
          </Grid>
        </CustomAddModal>
      }
    </Grid >
  );

}

export default withTranslation("translations")(withStyles(tablestyle)(Aggregates));